import { SET_ABN_TESTS, TSetAbnTests } from '~/src/store/reducers/city';

export const setAbnVariants = (variants: string): TSetAbnTests => ({
    type: SET_ABN_TESTS,
    payload: {
        abnTests: {
            variants,
            isSended: false,
        },
    },
});
